import type { BranchEventName } from './branchEventNames';

type BranchEventSink = (eventName: BranchEventName) => void;

let sink: BranchEventSink | null = null;

/** Mobile registers this once so shared auth flows can emit Branch events. */
export const registerBranchEventSink = (next: BranchEventSink | null): void => {
  sink = next;
};

/** No-op when the mobile sink is not registered (web). */
export const emitBranchEvent = (eventName: BranchEventName): void => {
  try {
    sink?.(eventName);
  } catch (error) {
    console.warn('[Branch Event] sink failed', error);
  }
};
